import { hiringManagerCandidatesJobsConstants } from "../../_constants";

const initialState = {};

//all mentors applied reducer
export const get_suggested_candidates_hiring_manager_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerCandidatesJobsConstants.GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerCandidatesJobsConstants.GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_SUCCESS:
      return {
        type: "alert-success",
        suggestedCandidatesData: action.payload,
        // data: action.payload
      };
    case hiringManagerCandidatesJobsConstants.GET_SUGGESTED_CANDIDATES_HIRING_MANAGER_ACTION_FAILURE:
      return {
        type: "alert-failure",
        errorData: action.payload,
      };
    default:
      return state;
  }
};


//all applied mentors reducer
export const get_all_applied_candidates_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case hiringManagerCandidatesJobsConstants.ALL_APPLIED_CANDIDATES_LIST_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case hiringManagerCandidatesJobsConstants.ALL_APPLIED_CANDIDATES_LIST_SUCCESS:
      return {
        type: "alert-success",
        appliedCandidatesData: action.payload,
      };
    case hiringManagerCandidatesJobsConstants.ALL_APPLIED_CANDIDATES_LIST_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};